import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckbox = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("rect", {
		x: .5,
		y: .5,
		width: 15,
		height: 15,
		rx: 3.5,
		fill: "transparent"
	})
});
export default SvgCheckbox;
